export const    UPDATE_CURRENT_URL = 'UPDATE_CURRENT_URL';
export const    DELETE_CURREMT_URL = 'DELETE_CURREMT_URL';